import { RootDispatch } from "redux/rootReducer";
import {
  load,
  loadSuccess,
  loadFail,
  loadCount,
  loadCountSuccess,
  loadCountFail,
} from "./covenantsActions";
import * as request from "utility/request";
import { Covenants } from "types/Covenants";

const apiUrl = process.env.REACT_APP_API_URL;

export const loadCovenants = (reportControlId: string, reportDate: string) => {
  return async (dispatch: RootDispatch) => {
    dispatch(load());

    try {
      const res = await request.getResponseJson<Covenants[]>(
        `${apiUrl}/api/covenants?reportControlId=${reportControlId}&reportDate=${reportDate}`
      );

      dispatch(loadSuccess(res));
    } catch (error) {
      return request.handleFetchError(dispatch, error, loadFail(error));
    }
  };
};

export const loadCovenantsCount = (reportControlId: string, reportDate: string) => {
  return async (dispatch: RootDispatch) => {
    dispatch(loadCount());

    try {
      const res = await request.getResponseJson<number>(
        `${apiUrl}/api/covenants/count?reportControlId=${reportControlId}&reportDate=${reportDate}`
      );

      dispatch(loadCountSuccess(res));
    } catch (error) {
      return request.handleFetchError(dispatch, error, loadCountFail(error));
    }
  };
};
